import './circularChart.css'

import React from 'react'
import { label as labelColor, lightGreen, orange } from 'styles'
import { emptyArray } from 'utils'

import Button from '@mui/material/Button'
import { ResponsivePie } from '@nivo/pie'

import useStyles from './useStyles'

interface Props {
  label: string
  openCompleteness: () => void
  values?: number[]
}

const baseChartData = [{ color: lightGreen }, { color: '#3f51b5' }, { color: '#cddc39' }]

function CircularChart({ label, openCompleteness, values = emptyArray }: Props) {
  const classes = useStyles()
  const totalAsNumber = Math.round(100 * values[0]) || 0
  const valuesSum = values.slice(1).reduce((a, b) => a + b, 0)
  const sumAsNumber = Math.round(100 * valuesSum)
  const chartData: any = values.slice(1).map((value, index) => ({
    ...(baseChartData[index] || baseChartData[0]),
    id: `${index}`,
    value: Math.round(100 * value),
  }))

  chartData.push({
    id: 'fill-to-total',
    color: orange,
    value: totalAsNumber - sumAsNumber,
  })
  chartData.push({
    id: 'fill-to-100',
    color: labelColor,
    value: 100 - totalAsNumber,
  })

  return (
    <Button className={classes.button} onClick={openCompleteness}>
      <div className="circular-chart-label">
        <div className="circular-chart-label-value">{label}</div>
      </div>
      <div className="circular-chart">
        <ResponsivePie
          innerRadius={0.9}
          enableRadialLabels={false}
          enableSlicesLabels={false}
          isInteractive={false}
          colorBy={d => `${d.color}`}
          data={chartData}
          margin={{
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          }}
        />
        <div className="circular-chart-value">
          {totalAsNumber}
          {values[0] >= 0 && <span className="circular-chart-value-percent">%</span>}
        </div>
      </div>
    </Button>
  )
}

export default CircularChart
